import React, { useState, useEffect } from "react";
import { Box, Card, CardContent, CardHeader, Typography, useMediaQuery } from "@mui/material"; // Import MUI components
import './slider.css'; // Import your CSS file
import image1 from "../../assets/empower.png";
import image2 from "../../assets//optmiza.png";
import image3 from "../../assets/accelerate.png";

const SliderBenifit = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const isXsScreen = useMediaQuery((theme) => theme.breakpoints.down('sm')); // Ensure theme is accessible
    // Array of cards with background images and content
    const cards = [
        { id: 1, header: " Tech-Driven Automotive Solutions", content: "Enabling your business to reach new heights with tailored, user-friendly software solutions.", imageUrl: image1 },
        { id: 2, header: "Optimize", content: "Maximizing efficiency and minimizing risks with state-of-the-art software and IT services.", imageUrl: image2 },
        { id: 3, header: "Accelerate", content: "Fueling your business growth with fast, secure, and scalable IT services.", imageUrl: image3 },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === cards.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000); // Change slide every 3 seconds

        return () => clearInterval(interval);
    }, [cards.length]);
    if (isXsScreen) {
        return null; // Hide slider on extra-small screens
      }
    
    return (
        <Box
            className="slider-container"
            sx={{
                width: "100%", height: "300px", overflow: "hidden", margin: "0 auto", marginTop: "20px", borderRadius: "30px", borderTopRightRadius: "20px", // Custom border shape
                // borderTopLeftRadius: "20px",
                borderBottomRightRadius: "20px",
                borderBottomLeftRadius: "20px",
                marginTop:"32px"
            }}
        >
            <Box
                className="slider-wrapper"
                sx={{
                    display: "flex",
                    transition: "transform 0.5s ease-in-out",
                    height:"300px",
                    transform: `translateX(-${currentIndex * 100}%)`,
                }}
            >
                {cards.map((card) => (
                    <Card
                        key={card.id}
                        sx={{
                            minWidth: "100%",
                            // height: "100%",
                            backgroundColor: "#0B77A8",
                            color: "white",
                            // height: "300px",
                            overflow: "hidden",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
                        }}
                    >
                        <CardHeader style={{ display: "grid" }}
                           
                            title={<Typography variant="h5" className='poppins-bold' >  {card.header}</Typography>}
                        />
                        <CardContent sx={{
                            // width: {
                            //     lg: "50%",
                            //     md: "100%"
                            // }
                        }}>
                            <Typography variant="h5" sx={{
                                fontSize: {
                                    lg: "1.2rem",
                                    md: "1rem",
                                    sm:"0.9rem",
                                    sx:"0.5rem"
                                }
                            }} className='poppins-semibold'>
                                {card.content}
                            </Typography>
                        </CardContent>
                    </Card>
                ))}
            </Box>
        </Box>
    );
};

export default SliderBenifit;

